export const STATUS_VALUES = {
  REQUESTED: "requested",
  APPROVED: "approved",
  REJECTED: "rejected",
  ALL: "",
};

export const STATUS_LABELS = {
  REQUESTED: "Requested",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  ALL: "All",
};

export const STATUS_OPTIONS = [
  { value: STATUS_VALUES.REQUESTED, label: STATUS_LABELS.REQUESTED },
  { value: STATUS_VALUES.APPROVED, label: STATUS_LABELS.APPROVED },
  { value: STATUS_VALUES.REJECTED, label: STATUS_LABELS.REJECTED },
  { value: STATUS_VALUES.ALL, label: STATUS_LABELS.ALL },
];

export const DEFAULT_HUB_ID = 1;

export const MESSAGE_TOP_OFFSET = 50;

export const DEFAULT_PAGE_SIZE = 10;

export const LOCAL_STORAGE_KEYS = {
  USER_INFO: "userinfo",
};

export const SOURCE_HUB_APP = "HUB_APP";

export const BEARER_PREFIX = "Bearer";

export const ERROR_MESSAGES = {
  FETCH_FAILED: "Failed to load RTO request data",
  STATUS_UPDATE_FAILED: (nextStatus, awbNumber) => `Failed to ${nextStatus} for AWB ${awbNumber}`,
  USER_INFO_PARSE_FAILED: "Failed to parse userinfo from localStorage",
};

export const SUCCESS_MESSAGES = {
  STATUS_UPDATED: (nextStatus, awbNumber) => `Status ${nextStatus} for AWB ${awbNumber}`,
};

export const CONFIRM_MESSAGES = {
  APPROVE: "Are you sure you want to approve this?",
  REJECT: "Are you sure you want to reject this?",
};

export const BUTTON_LABELS = {
  APPROVE: "Approve",
  REJECT: "Reject",
  CLEAR: "Clear",
};

export const POPCONFIRM_TEXTS = {
  YES: "Yes",
  NO: "No",
};

export const PLACEHOLDERS = {
  SEARCH_AWB: "Search AWB number",
  SEARCH_CP_ID: "Search CP Id",
  EMPTY_VALUE: "-",
};

export const PAGE_TITLES = {
  RTO_REQUEST_APPROVALS: "RTO Request Approvals",
};

export const NAVIGATION_PATHS = {
  APPROVALS_SETTINGS: "/approvals-settings",
  SHIPMENT_TRACKER: (awb) => `/shipment-tracker?awb=${awb}`,
  TARGET_BLANK: "_blank",
};

export const DATE_FORMATS = {
  INPUT: "DD/MM/YYYY HH:mm:ss",
  DISPLAY: "DD-MM-YYYY | HH:mm:ss",
};

export const TABLE_COLUMN_KEYS = {
  INDEX: "index",
  AWB_NUMBER: "awbNumber",
  CP_NAME: "cpName",
  CP_ID: "cpId",
  STATUS: "status",
  RTO_REASON: "rtoReason",
  REMARKS: "remarks",
  REQUESTED_DATE: "requestedDate",
  ACTION: "action",
};

export const TABLE_COLUMN_TITLES = {
  INDEX: "S.No",
  AWB_NUMBER: "Awb Number",
  CP_NAME: "CP Name",
  CP_ID: "CP Id",
  STATUS: "Status",
  RTO_REASON: "RTO Reason",
  REMARKS: "Remarks",
  REQUESTED_DATE: "Requested Date",
  ACTION: "Action",
};

export const TABLE_ALIGN = {
  CENTER: "center",
};

export const UI_SIZES = {
  SMALL: "small",
  LARGE: "large",
  ROUND: "round",
};

export const ALT_TEXTS = {
  LOADER: "loader",
  SEARCH: "search",
};

export const ICON_COLORS = {
  GREEN: "green",
  RED: "red",
  LINK_BLUE: "#1890ff",
  WHITE: "#fff",
};

export const STATUS_COLORS = {
  APPROVED: "#52c41a",
  REJECTED: "#ff4d4f",
};

export const CSS_CLASSES = {
  CONTAINER: "approvals-rto-request-page",
  SELECT_DROPDOWN: "rto-status-select",
};

export const SHOW_TOTAL_PAGINATION = (total, range) => `${range[0]}-${range[1]} of ${total} items`;

export const approveButtonStyle = (isDisabled) => ({
  backgroundColor: STATUS_COLORS.APPROVED,
  borderColor: STATUS_COLORS.APPROVED,
  color: ICON_COLORS.WHITE,
  opacity: isDisabled ? 0.5 : 1,
  cursor: isDisabled ? "not-allowed" : "pointer",
});

export const rejectButtonStyle = (isDisabled) => ({
  backgroundColor: STATUS_COLORS.REJECTED,
  borderColor: STATUS_COLORS.REJECTED,
  color: ICON_COLORS.WHITE,
  opacity: isDisabled ? 0.5 : 1,
  cursor: isDisabled ? "not-allowed" : "pointer",
});
